// The IR blaster on the desktop shell.
//
// The remote is a FLOATING HANDSET over the page, not the page itself — see the
// note in RemoteHandset. Closing it with the × leaves this screen showing what
// the remote is and how to pick it up again; nothing is lost and nothing needs
// navigating back to.
//
// `outputs` and `initialStatus` arrive from DeviceControls for every type.
// `outputs` is always empty for a blaster — probed live, OutputDetails returns
// zero rows — and `initialStatus` is an ACK sentence rather than a state, so it
// is passed through for display only.

import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import DeviceShell from '../../components/DeviceShell';
import RemoteHandset from '../../../shared/remote/RemoteHandset';

export default function IrRemoteScreen({ device, initialStatus = '' }) {
  const [open, setOpen] = useState(true);
  const name = device.DeviceName || device.UniqueNumber;

  return (
    <DeviceShell title={name}>
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 4,
        color: 'text.secondary', textAlign: 'center',
      }}
      >
        <SettingsRemoteIcon sx={{ fontSize: 44, opacity: 0.5 }} />
        <Typography variant="body2">
          {open
            ? 'The remote is open — it floats over the page so you can keep working behind it.'
            : 'The remote is closed.'}
        </Typography>
        {!open && (
          <Button variant="contained" size="small" startIcon={<SettingsRemoteIcon />} onClick={() => setOpen(true)}>
            Open remote
          </Button>
        )}
        <Typography variant="caption" sx={{ opacity: 0.7, maxWidth: 380 }}>
          An IR blaster transmits only — it cannot report whether the appliance responded, so the
          handset shows what was sent rather than what happened.
        </Typography>
      </Box>

      {open && (
        <RemoteHandset
          floating
          uniqueNumber={device.UniqueNumber}
          deviceName={name}
          initialStatus={initialStatus}
          onClose={() => setOpen(false)}
        />
      )}
    </DeviceShell>
  );
}
